import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    makeStyles
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { closeAddItemTypesDialog } from "./item-types-add-slice";
import { db } from "../../../../firebase";
import { useState } from "react";
import { addItemTypesService } from "./item-types-add-service";
import { showErrorSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#111111",
        color: "#fbbbd3",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
        color: "#111111",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    title: {
        background:"#111111",
    },
    text: {
        color: "#111111",
    },
}));

const initiaFormData = {
    code: "",
    name: "",
    description: "",
};

const ItemTypesAdd = () => {
    const classes = useStyles();
    const showDialog = useSelector((state) => state.itemTypesAddSlice.showDialog);
    const isLoading = useSelector((state) => state.itemTypesAddSlice.isLoading);
    const [formData, setFormData ] = useState(initiaFormData);
    const dispatch = useDispatch();

    // handle input
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value
        });
    };

    // handle add
    const handleAddSubmit = async (e) => {
        e.preventDefault();  
       
        try {
            await addItemTypesService(dispatch, db, "item_types", formData);
          } catch (e) {
            dispatch(showErrorSnackbar("Something went wrong while trying to add."));
            console.error("ItemTypesAdd handleAddSubmit: ", e);
          }
        handleAddClose();
    };

    // handle close add
    const handleAddClose = () => {
        setFormData(initiaFormData);
        dispatch(closeAddItemTypesDialog());
    };

    return (
        <Dialog
            open={showDialog}
        >
            <DialogTitle className={classes.title}>
                Add Item Type
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TextField
                            id="filled-basic"
                            label="Code"
                            variant="filled"
                            fullWidth
                            name="code"
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TextField
                            id="filled-basic"
                            label="Name"
                            variant="filled"
                            fullWidth
                            name="name"
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TextField
                            id="filled-basic"
                            label="Description"
                            variant="filled"
                            fullWidth
                            name="description"
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    className={classes.button}
                    onClick={handleAddSubmit}
                    disabled={isLoading}
                >
                    {
                        isLoading ? (
                            "Adding..."
                        ) : (
                            "Add"
                        )
                    }
                </Button>
                <Button
                    variant="text"
                    className={classes.buttonText}
                    onClick={handleAddClose}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ItemTypesAdd;